import {
  PackageBundleBooking,
  PackageBundleBookingAppliedStatus,
} from "../../types/package.bundle";
import { generateAPI } from "../api.generator";

export const getAllPackageBundleBookings = generateAPI<
  {
    query: {
      appliedStatus: PackageBundleBookingAppliedStatus;
    };
  },
  PackageBundleBooking[]
>("get", "package-bundle/bookings");
